<!-- <div class="time-series-chart fw fh">
    <div class="chart-area fw fh"></div>
    <div class="no-data fw fh"
        *ngIf="!data?.length">
        <span>{{'common.no_data_small' | translate}}.</span>
    </div>
</div> -->

<div id="simpleTimeChart"></div>